import moment from 'moment-timezone';

function date(date) {
    if (!date) return '';
    return moment.utc(date).tz('America/Sao_Paulo').format('DD/MM/YY');
}

function datetime(date) {
    if (!date) return '';
    return moment.utc(date).tz('America/Sao_Paulo').format('DD/MM/YY HH:mm');
}

export {
    date,
    datetime
}